import {Component, Input} from '@angular/core';
import { AbstractControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-toggle',
    template: `
    <mat-slide-toggle color="primary" class="slm-toggle"
                      [formControl]="control"
                      [attr.data-test-id]="testId"
                      [class.slm-toggle--invalid]="(control?.dirty || control?.touched) && control?.invalid"
                      [class]="uniqueClass">
      <ng-container *ngIf="!isInnerHtml; else innerHTML">{{
        label | translate
        }}</ng-container>
    </mat-slide-toggle>
    <ng-template #innerHTML>
      <div [innerHTML]="label | translate"></div>
    </ng-template>
  `,
    imports: [MatSlideToggle, FormsModule, ReactiveFormsModule, NgIf, TranslatePipe]
})
export class ToggleComponent {
  @Input() public label = '';
  @Input() public testId = '';
  @Input() public isInnerHtml = false;
  @Input() public control: UntypedFormControl | AbstractControl;
  @Input() public uniqueClass = '';
}
